import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../shared-service/shared.service';

@Injectable({
    providedIn: 'root'
})

export class AppService {

    public user: any = null;

    constructor(private router: Router,private sharedService: SharedService,) { }

    logout() {
        this.user = null;
        this.router.navigate(["/login"]);
        this.sharedService.clearStorage();
    }
}